// Диспетчер триггеров и активок Деуса (А.4.4.1+2+3).
// Все ability-функции живут отдельными файлами в этой папке.
// Эти on*-функции вызываются движком в нужных точках хода.

import { tanakiActive, tanakiActiveAvailable } from './tanaki-active.js';
import { kirosaEot } from './kirosa-eot.js';
import { nikosiOnHeroAttack } from './nikosi-attack.js';
import { nikosiActive, nikosiActiveAvailable } from './nikosi-active.js';
import { sinaOnUnitDied } from './sina-unit-death.js';
import { sinaActive, sinaActiveAvailable } from './sina-active.js';
import { kirosaActive, kirosaActiveAvailable, getKirosaTargets } from './kirosa-active.js';
import { analitikDeathrattle, CARD_ID as ANALITIK_ID } from './analitik-deathrattle.js';
import { dronOnDamage, CARD_ID as DRON_ID } from './dron-on-damage.js';
import { auditorEot, CARD_ID as AUDITOR_ID } from './auditor-eot.js';
import { fudziKillUnit, CARD_ID as FUDZI_ID } from './fudzi-kill-unit.js';

// А.4.4.2+3 — новые модули.
import { ohrannyyBotEot, CARD_ID as OHRANNYY_ID } from './ohrannyy-bot.js';
import { sekretarEot, CARD_ID as SEKRETAR_ID } from './sekretar.js';
import { likvidatorOnHeroAttack } from './likvidator.js';
import { stazherEot, CARD_ID as STAZHER_ID } from './stazher-eot.js';
import { botOpergruppyDeathrattle, CARD_ID as BOT_OPER_ID } from './bot-opergruppy.js';
import { krizisMenedzherOrder, CARD_ID as KRIZIS_ID } from './krizis-menedzher.js';
import { iiYadroOnTurnStart, iiYadroOnEndOfTurn, CARD_ID as YADRO_ID } from './ii-yadro.js';
import { recomputeDirectorAura } from './vtoroy-direktor.js';
import {
  registerUnitDiedHandler, fireOnTurnStartExtras, fireOnUnitDiedExtras,
  fireOnEndOfTurnExtras
} from './hooks.js';
// А.4.4.4 — закрытие отложенных механик.
import { auditorOrderLine1, auditorOrderLine2 } from './auditor-eot.js';
import { intendantOrder, CARD_ID as INTENDANT_ID } from './intendant.js';
import { sovetOrder, CARD_ID as SOVET_ID } from './sovet-aktsionerov.js';
import {
  runArmedSpyAttacks, armSpy, getActivatableSpies,
  CARD_ID as SPY_ID
} from './spyaschiy-agent.js';
// А.4.5-fix5: Танаки passive «+0/1/1 самому слабому в начале хода».
import { tanakiPassiveOnTurnStart } from './tanaki-passive.js';
// Б.1.d: Синтетикс — Рипер trigger (Мод в руку каждый ход), Дилер order (Мод из колоды).
import { riperOnTurnStart } from '../syntetics/riper-trigger.js';
import { dilerOrder, CARD_ID as DILER_ID } from '../syntetics/diler.js';
// Б.2.a: триггеры Модов Синтетикса на смерть и на конец хода.
import {
  applyModDeathTriggers,
  applyModEndOfTurnTriggers,
  attachMod
} from '../syntetics/modifications.js';
// Б.2.c: 5 простых юнитов Синтетикса.
import { torchokOnTurnEnd, CARD_ID as TORCHOK_ID } from '../syntetics/torchok.js';
import { narkolaboratoriyaOnTurnStart, CARD_ID as NARKO_ID } from '../syntetics/narkolaboratoriya.js';
import { notifyCharacterDamaged } from '../syntetics/temnyy-netranner.js';
// Б.2.d: 6 сложных юнитов Синтетикса.
import { fikserOnTurnStart, fikserOrder, CARD_ID as FIKSER_ID } from '../syntetics/fikser.js';
import { tehnoPalachOrder, CARD_ID as PALACH_ID } from '../syntetics/tehno-palach.js';
import { zakalennyyOnAnyUnitDamaged, CARD_ID as ZAKAL_ID } from '../syntetics/zakalennyy-kiber-psih.js';
import { iiModelEot, CARD_ID as IIMODEL_ID } from '../syntetics/ii-model.js';
import { lichnyyOnSpawn, CARD_ID as LICHNYY_ID } from '../syntetics/lichnyy-telohranitel.js';
import { initsiatorOnSpawn, initsiatorOnEndOfTurn, CARD_ID as INITSIATOR_ID } from '../syntetics/initsiator.js';
// C.1: Цепь командования удалена. Линейно-триггерные keyword'ы остаются.
import { recomputeLineTriggers, clearDerivedKeywordsFor } from '../../keywords/line-triggers.js';
// БУГ.7: legacy glb_* импорты из global/index.js удалены. Карт с такими
// ID нет в v6 cards-global.js, все case'ы в fireUnitOrderById switch и
// вызовы в onHeroAttack/onTurnStart/EOT для них были безоперационными.
// Реальные v6-юниты Глобала обрабатываются через default-case → fireC1Order.
// В.1.c-2: late-binding для fireUnitOrderById (используется Офицером связи).
import { _setFireUnitOrderById } from '../global/ofitser_svyazi.js';
// В.2.d-1: Лив Лайф rare — Дрон-дефибриллятор Order.
import {
  dronDefibrillyatorOrder as livDronDefibrillyatorOrder,
  CARD_ID as LIV_DEFIBRILLYATOR_ID
} from '../livlife/dron_defibrillyator.js';
// В.2.d-2: Лив Лайф rare — Опытный хирург, Медик-штурмовик Order.
import {
  opytnyyHirurgOrder as livOpytnyyHirurgOrder,
  CARD_ID as LIV_HIRURG_ID
} from '../livlife/opytnyy_hirurg.js';
import {
  medikShturmovikOrder as livMedikShturmovikOrder,
  CARD_ID as LIV_SHTURMOVIK_ID
} from '../livlife/medik_shturmovik.js';
// В.2.e-1: Лив Лайф epic — Правая рука Лизы Order.
import {
  pravayaRukaLizyOrder as livPravayaRukaLizyOrder,
  CARD_ID as LIV_PRAVAYA_RUKA_ID
} from '../livlife/pravaya_ruka_lizy.js';
// В.2.f-1: Лив Лайф legendary — Матрица Клонирования и Доктор Франк Order.
import {
  matritsaKlonirovaniaOrder as livMatritsaOrder,
  CARD_ID as LIV_MATRITSA_ID
} from '../livlife/matritsa_klonirovaniya.js';
import {
  doktorFrankenOrder as livDoktorFrankenOrder,
  CARD_ID as LIV_DOKTOR_FRANKEN_ID
} from '../livlife/doktor_franken.js';
// C.1: единый реестр Order-функций для v6-карт (Глобал + Лив Лайф + Деус).
import { fireC1Order } from '../global/c1/order-registry.js';
// C.1: реализации юнитов Деуса под v6 ID.
import './c1/units-batch.js';

// Этап 25: регистрация Героев Деуса (реализации в *-active.js / *-eot.js).
import { registerImplementedAbility } from '../warn-unimplemented.js';
for (const id of ['deus_kirosa', 'deus_nikosi', 'deus_sina', 'deus_tanaki']) {
  registerImplementedAbility(id, 'active', 'trigger');
}

export {
  tanakiActive, tanakiActiveAvailable,
  nikosiActive, nikosiActiveAvailable,
  sinaActive, sinaActiveAvailable,
  kirosaActive, kirosaActiveAvailable, getKirosaTargets,
  recomputeDirectorAura,
  runArmedSpyAttacks, armSpy, getActivatableSpies,
  auditorOrderLine1, auditorOrderLine2,
  intendantOrder, sovetOrder,
  KRIZIS_ID, YADRO_ID, SPY_ID, INTENDANT_ID, SOVET_ID
};

// === Триггеры ===

// Атака Героя (только инициированная — не ответный удар).
export function onHeroAttack(state, { attackerIdx }) {
  nikosiOnHeroAttack(state, attackerIdx);
  // Ликвидаторы всех владельцев — атаковал свой Герой → +1 atk на каждом Ликвидаторе.
  likvidatorOnHeroAttack(state, attackerIdx);
  // БУГ.7: вызов mayorIvOnHeroAttack удалён (был noop для legacy 'glb_mayor_iv').
  // Новый Герой 'global_iv' использует ivOnEndOfTurn — регистрируется в
  // global/index.js через registerOnEndOfTurnExtraHandler.
}

// Юнит ownerIdx получил урон > 0 от source (любого).
export function onUnitDamaged(state, { ownerIdx, card, dmg }) {
  if (!card || dmg <= 0) return;
  if (card.id === DRON_ID) dronOnDamage(state, ownerIdx);
  // Б.2.c: Тёмный нетраннер — союзный юнит получил урон → шот по случайному врагу.
  notifyCharacterDamaged(state, ownerIdx, card, dmg);
  // Б.2.d: Закалённый кибер-псих — +1/+1/0 при любом уроне по юниту.
  zakalennyyOnAnyUnitDamaged(state, ownerIdx, card, dmg);
}

// Б.2.c: Герой defenderIdx получил урон > 0. Параллельно onUnitDamaged.
// Используется для всех путей урона по Герою (авто-атака, Ф4/5, applyHeroDamage,
// колода пуста, прогрессия Модов).
export function onHeroDamaged(state, defenderIdx, dmg) {
  if (dmg <= 0) return;
  const hero = state.players[defenderIdx]?.hero;
  if (!hero) return;
  notifyCharacterDamaged(state, defenderIdx, hero, dmg);
}

// Юнит ownerIdx умер. killer — карта-источник смерти (Card | null), killerIdx — её владелец (idx | null).
// killerWasCounter=true если юнит погиб от ответного удара (важно для Фудзи).
//
// В.1.g-fix1: Молчание блокирует Посмертие (по диздоку 6.7 — текстовая
// способность). Любой Посмертия (deathrattle) — Аналитик, Бот опергруппы,
// Дредноут, Эксп. батарея/Второе сердце через Мод — не срабатывает, если
// юнит был под Молчанием на момент смерти. Сторонние эффекты, не привязанные
// к способности самой умершей карты (Сина, Фудзи, Цепь, ауры) — продолжают
// работать (это не текстовые способности умершего юнита).
export function onUnitDied(state, { ownerIdx, card, killer, killerIdx, killerWasCounter }) {
  // А.4.4.4-fix1: смерть Спящего агента у врага — обычная смерть, БЕЗ deathrattle/Сины.
  const spyDeathOnEnemySide = card?.sleeperState != null;
  // В.1.g-fix1: флаг Молчания на самой умершей карте — блокирует все её
  // собственные Посмертия (но не сторонние реакции вроде Сины/Фудзи).
  const silenced = !!(card && card.current && card.current.silenced);
  // noTriggers — ванильная копия (Конвейер тел): свои Посмертия НЕ запускает
  // (но сторонние реакции на её смерть через fireOnUnitDiedExtras — да).
  const suppressOwn = silenced || !!(card && card.noTriggers);
  // Сина: мой юнит ушёл в сброс — мой Герой получает +1 (если это не спящий у врага).
  // Сина — это эффект ГЕРОЯ Сины (не самой умершей карты), Молчание умершего на неё не влияет.
  sinaOnUnitDied(state, ownerIdx, card);
  // Deathrattle Аналитика — Влияние идёт владельцу (если не спящий у врага).
  if (!spyDeathOnEnemySide && !suppressOwn && card && card.id === ANALITIK_ID) {
    analitikDeathrattle(state, ownerIdx);
  }
  // А.4.4.2-fix1 (баг 6): Фудзи срабатывает на ЛЮБОЕ убийство — прямая атака или ответка.
  // Это эффект УБИЙЦЫ (Фудзи), а не умершей карты — Молчание умершего не блокирует.
  if (killer && killer.id === FUDZI_ID && killerIdx != null) {
    fudziKillUnit(state, killerIdx);
  }
  // Бот опергруппы — deathrattle (если не спящий у врага и не под Молчанием).
  if (!spyDeathOnEnemySide && !suppressOwn && card && card.id === BOT_OPER_ID) {
    botOpergruppyDeathrattle(state, ownerIdx, card);
  }
  // БУГ.7: Дредноут (legacy 'glb_drednout') — Посмертие удалено, карта не
  // в v6 cards-global.js. Новые легендарки Глобала используют C.1
  // deathrattle-механизмы.
  // Б.2.a: триггеры Модов на смерть носителя (Эксп. батарея, Второе сердце).
  // Молчание Синтетика снимает Моды при наложении (см. silence.js#detachMod);
  // если Мод повешен ПОСЛЕ Молчания и осталось активным — Посмертие Мода также
  // блокируется (Мод — текстовая способность, висит на молчащем юните).
  // Не запускаем для Спящего у врага (Б.2.a не описывает кросс-сторонние сценарии).
  if (!spyDeathOnEnemySide && !suppressOwn && card) {
    applyModDeathTriggers(state, ownerIdx, card);
  }
  // В.1.g-fix1: лог про блокировку Посмертия Молчанием — для прозрачности.
  if (silenced && !spyDeathOnEnemySide && card) {
    state.log?.add(`🤐 ${card.name_ru} был под Молчанием — Посмертие НЕ сработало`);
  }
  // Аура Второго директора — пересчёт (если умер директор или его подопечный).
  recomputeDirectorAura(state);
  // C.1: Цепь командования удалена.
  // В.1.c-1: чистим derivedKeywords умершей карты + общий пересчёт.
  if (card) clearDerivedKeywordsFor(card);
  recomputeLineTriggers(state);
  // В.1.d: late-bound extras (Аура Генератора помех — Генератор умер /
  // его враг-цель умер). registerOnUnitDiedExtraHandler в hooks.js.
  fireOnUnitDiedExtras(state, { ownerIdx, card, killer, killerIdx, killerWasCounter });
}

// А.4.4.2-fix1 (баг 3): регистрируем onUnitDied как dispatch-обработчик для не-боевых смертей.
registerUnitDiedHandler((state, payload) => onUnitDied(state, payload));

// Конец хода (после Ф5, до cleanup).
export function onEndOfTurn(state) {
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    // Триггер Героя
    kirosaEot(state, idx);
    // Триггеры юнитов на поле — снимок до возможных модификаций
    const units = [...p.unitsOnField()];
    for (const u of units) {
      if (!u.isAlive() || u.isSleeping(state.currentTurn)) continue;
      switch (u.id) {
        case AUDITOR_ID:  auditorEot(state, idx); break;
        case OHRANNYY_ID: ohrannyyBotEot(state, idx, u); break;
        case SEKRETAR_ID: sekretarEot(state, idx, u); break;
        case YADRO_ID:    iiYadroOnEndOfTurn(state, idx, u); break;
        // Б.2.c: Торчок — 1 урон случ. союзному юниту + случ. вражескому
        // юниту. Раньше было ДВА триггера (DoT + копия), но xlsx v6
        // имеет только один — turn_end (DoT). Копии убраны.
        case TORCHOK_ID:  torchokOnTurnEnd(state, idx, u); break;
        case IIMODEL_ID:  iiModelEot(state, idx, u); break;       // Б.2.d
      }
    }
    // Стажёры — общий триггер на сторону, один раз.
    stazherEot(state, idx);
    // Б.2.a: триггеры Модов Синтетикса в EOT (Цифровое завещание, Выч. мощности).
    applyModEndOfTurnTriggers(state, idx);
    // Б.2.d: декремент TTL эффекта Инициатора.
    initsiatorOnEndOfTurn(state, idx);
    // БУГ.7: polkovnikMitEot (noop для legacy 'glb_polkovnik_mit') удалён.
    // Новый Герой 'global_mit' регистрирует mitOnEndOfTurn в global/index.js.
  }
  // В.2.d-2: общий extra-handler EOT (Лив Лайф Крыса и т.п.).
  fireOnEndOfTurnExtras(state);
}

// Начало хода (после Ф1: тяга) — для триггеров «в начале каждого хода».
export function onTurnStart(state) {
  // C.1: Цепь командования удалена. Подкрепление пересчёт через reinforcement.js (когда появится).
  // В.1.c-1: line-triggers — пробудившийся юнит мог получить keyword по линии.
  recomputeLineTriggers(state);
  for (let idx = 0; idx < 2; idx++) {
    // Триггер Героя — Танаки-passive (А.4.5-fix5).
    tanakiPassiveOnTurnStart(state, idx);
    // Б.1.d: Рипер trigger — случайный Мод из общего пула фракции в руку.
    riperOnTurnStart(state, idx);
    // БУГ.7: strategLiPulOnTurnStart и komissarYarOnTurnStart были noop'ами
    // для legacy Героев ('glb_strateg_li_pul', 'glb_komissar_yar'). Новые
    // Герои 'global_li_pul' и 'global_rayna' регистрируют свои триггеры
    // в global/index.js через registerOnTurnStartExtraHandler.
    const p = state.players[idx];
    const units = [...p.unitsOnField()];
    // Б.2.d: spawn-on-wake — для юнитов, проснувшихся в этот ход (placedTurn <
    // currentTurn И initiation === currentTurn). Запускаем ДО per-юнитовых
    // триггеров, чтобы Инициатор успел активировать TTL до Фазы 2.
    for (const u of units) {
      if (!u.isAlive()) continue;
      if (u.spawnPassiveFired) continue;
      if (u.isSleeping(state.currentTurn)) continue;
      // На свежевыставленных не сработает: они обработаны в commitPlacementsAndReveal.
      if (u.placedTurn != null && u.placedTurn >= state.currentTurn) continue;
      fireSyntheticOnSpawnPassive(state, idx, u);
      u.spawnPassiveFired = true;
    }
    for (const u of units) {
      if (!u.isAlive() || u.isSleeping(state.currentTurn)) continue;
      if (u.id === YADRO_ID) iiYadroOnTurnStart(state, idx, u);
      // Б.2.c: Нарколаборатория — Мод союзнику в чётный ход.
      if (u.id === NARKO_ID)   narkolaboratoriyaOnTurnStart(state, idx, u, attachMod);
      // Б.2.d: Фиксер — пассив +0/1/0 каждый ход.
      if (u.id === FIKSER_ID)  fikserOnTurnStart(state, idx, u);
      // БУГ.7: триггеры для legacy 'glb_granatometchik', 'glb_polevoy_medik',
      // 'glb_meh_prikrytiya_pehoty' удалены (карт с этими ID нет в v6).
    }
  }
  // В.1.d: late-bound пересчёт аур после всех per-юнитовых триггеров
  // (Аура Генератора помех — учитывает проснувшихся в этом ходу).
  fireOnTurnStartExtras(state);
}

// Б.2.d: запуск spawn-passive для Синтетика-юнита в момент пробуждения.
// Используется и из commitPlacementsAndReveal (после placeCard), и из
// onTurnStart (для уже выставленных, проснувшихся в этом ходу).
export function fireSyntheticOnSpawnPassive(state, ownerIdx, card) {
  if (!card) return;
  switch (card.id) {
    case LICHNYY_ID:    lichnyyOnSpawn(state, ownerIdx, card); break;
    case INITSIATOR_ID: initsiatorOnSpawn(state, ownerIdx, card); break;
  }
}

// В.1.c-2: late-bind — Офицер связи зовёт Order разыгранной из руки карты.
_setFireUnitOrderById((state, ownerIdx, unit, orderOpts) =>
  fireUnitOrderById(state, ownerIdx, unit, orderOpts)
);

// В.1.c-2: одиночный диспетчер Order для конкретного юнита.
// Используется как изнутри runUnitOrdersOnReveal (стандартный путь), так и
// извне (Офицер связи line 1 — играет карту-юнит и сразу зовёт её Order).
export function fireUnitOrderById(state, ownerIdx, unit, orderOpts = {}) {
  if (!unit) return;
  switch (unit.id) {
    case KRIZIS_ID:    krizisMenedzherOrder(state, ownerIdx, unit); break;
    case 'deus_auditor_banka':
      if (unit.line === 0) auditorOrderLine1(state, ownerIdx, orderOpts);
      else                 auditorOrderLine2(state, ownerIdx, { ...orderOpts, selfCard: unit });
      break;
    case INTENDANT_ID: intendantOrder(state, ownerIdx); break;
    case SOVET_ID:     sovetOrder(state, ownerIdx, orderOpts); break;
    case DILER_ID:     dilerOrder(state, ownerIdx, unit); break;
    case PALACH_ID:    tehnoPalachOrder(state, ownerIdx, unit); break;
    case FIKSER_ID:    fikserOrder(state, ownerIdx, unit, orderOpts); break;
    // БУГ.7: case'ы для legacy glb_* юнитов удалены (MEDIK_ID, REKRUTER_ID,
    // GLB_DRON_ID, OPERATOR_ID, NETRANNER_ID, OFITSER_ID, INTENDANT_TYLA_ID,
    // SAPER_ID, GREYVS_ID, REPLIKATOR_ID). Новые v6-юниты Глобала
    // обрабатываются через default-case → fireC1Order.
    // В.2.d-1: rare Лив Лайф.
    case LIV_DEFIBRILLYATOR_ID:
      livDronDefibrillyatorOrder(state, ownerIdx, unit, orderOpts); break;
    // В.2.d-2: сложные rare Лив Лайф.
    case LIV_HIRURG_ID:
      livOpytnyyHirurgOrder(state, ownerIdx, unit, orderOpts); break;
    case LIV_SHTURMOVIK_ID:
      livMedikShturmovikOrder(state, ownerIdx, unit, orderOpts); break;
    // В.2.e-1: epic Лив Лайф.
    case LIV_PRAVAYA_RUKA_ID:
      livPravayaRukaLizyOrder(state, ownerIdx, unit, orderOpts); break;
    // В.2.f-1: legendary Лив Лайф.
    case LIV_MATRITSA_ID:
      livMatritsaOrder(state, ownerIdx, unit, orderOpts); break;
    case LIV_DOKTOR_FRANKEN_ID:
      livDoktorFrankenOrder(state, ownerIdx, unit, orderOpts); break;
    default:
      // C.1: новые v6-карты регистрируют Order через registerC1Order.
      fireC1Order(state, ownerIdx, unit, orderOpts);
      break;
  }
}

// Order'ы юнитов, размещённых в текущем ходу (срабатывают в Ф3 после Действий, до авто-атак).
// А.4.4.4: Аудитор, Интендант, Совет акционеров — orders с opts (выбор UI или авто для бота).
// state.pendingOrderOpts[ownerIdx][cardInstanceId] = {опции из UI}
//
// Б.2.d: для спящих эпиков/легендарок (Техно-палач, Фиксер не спит — но для общности)
// Order срабатывает В МОМЕНТ ПРОБУЖДЕНИЯ, не размещения. Условие пробуждения:
// placedTurn < currentTurn И initiation === currentTurn И !orderFiredAtSpawn.
export function runUnitOrdersOnReveal(state) {
  const opts = state.pendingOrderOpts || [{}, {}];
  // В.1.c-2: per-Ф3 сброс флага orderFiredThisTurn (Офицер связи может вызвать
  // дополнительный fireUnitOrderById для разыгранной из руки карты — этот флаг
  // не даёт Офицеру повторно сработать на самом себе).
  for (const p of state.players) {
    for (let line = 0; line < 2; line++) {
      for (let slot = 0; slot < 4; slot++) {
        const u = p.field[line][slot];
        if (u) u.orderFiredThisTurn = false;
      }
    }
  }
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    const units = [...p.unitsOnField()];
    for (const u of units) {
      if (!u.isAlive()) continue;
      // Б.2.d: Order не срабатывает на спящего юнита. Если выставлен в этом ходу
      // и спит (Эпика/Легендарка с initiation>currentTurn) — Order ждёт пробуждения.
      if (u.isSleeping(state.currentTurn)) continue;
      const fresh = u.placedTurn === state.currentTurn;
      const wokenUp = !u.orderFiredAtSpawn
                   && u.placedTurn != null
                   && u.placedTurn < state.currentTurn
                   && (u.initiation || 0) === state.currentTurn;
      if (!fresh && !wokenUp) continue;
      // В.1.c-2: защитный флаг — после Order'а Офицер связи помечается, чтобы
      // не сработал второй раз при возможном повторном проходе runUnitOrdersOnReveal.
      if (u.orderFiredThisTurn) continue;
      u.orderFiredThisTurn = true;
      const orderOpts = opts[idx]?.[u.instanceId] || {};
      fireUnitOrderById(state, idx, u, orderOpts);
      if (wokenUp) u.orderFiredAtSpawn = true;
    }
  }
  // Очистить опции после применения.
  state.pendingOrderOpts = [{}, {}];
}
